export const WELCOME_OFFER_CODE = "instant-access";

// Temp: flip to true to re-enable welcome-offer surfaces (panel empty state +
// FAB welcome-offer pill). When false, the panel uses tabs-with-empty-states
// and the FAB collapses to the greeting variant.
export const WELCOME_OFFER_ENABLED = false;

const APPLY_PENDING_KEY = "so_welcome_offer_apply_pending";

/**
 * Shopify sets a readable `discount_code=<code>` cookie after the customer
 * hits `/discount/<code>`, and clears it on checkout completion. Reading the
 * cookie gives us authoritative state — no manual TTL, no cross-tab drift.
 */
export function isWelcomeCodeApplied(): boolean {
  if (typeof document === "undefined") return false;
  const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  if (!match) return false;
  try {
    return decodeURIComponent(match[1]) === WELCOME_OFFER_CODE;
  } catch {
    return match[1] === WELCOME_OFFER_CODE;
  }
}

/**
 * Mark that the user just initiated the welcome-offer apply flow, so the
 * widget can auto-open into the success state on the post-redirect mount.
 */
export function markWelcomeOfferApplyPending(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(APPLY_PENDING_KEY, "1");
  } catch {
    /* sessionStorage unavailable (private mode) — auto-open simply won't fire */
  }
}

/** Returns true if an apply is pending; clears the marker as a side-effect. */
export function consumeWelcomeOfferApplyPending(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const pending = sessionStorage.getItem(APPLY_PENDING_KEY) === "1";
    if (pending) sessionStorage.removeItem(APPLY_PENDING_KEY);
    return pending;
  } catch {
    return false;
  }
}
